import { resources } from "@constants/hardcoded-strings";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { updateRelyingParties } from "@redux/actions/relying-parties-actions";
import { restoreRelyingPartyRequest } from "@requests/axnadmin-core/restore-relying-party";

export const restoreRelyingPartyReduxRequest = (dispatch: Dispatch) => async (
    relyingPartyId: string
): Promise<AxnRelyingParty> => {
    const { data, error } = await restoreRelyingPartyRequest(relyingPartyId);
    if (data) {
        displaySuccessModal(
            dispatch,
            resources.requests.restoreRelyingParty.success.title,
            resources.requests.restoreRelyingParty.success.message
        );
        dispatch(updateRelyingParties(data.transferObject, GenericAccountStateTypes.RESTORE));
        return data.transferObject;
    } else {
        if (error) {
            const errorResource = resources.requests.restoreRelyingParty.error;

            logAndDisplayErrorModal(
                dispatch,
                error,
                errorResource.title,
                errorResource.message
            );
        }
    }

    return null;
};